
import * as types from '../constants/ActionTypes'
import omit from 'lodash/omit'

export default function sessions(state = {}, action) {
	switch (action.type) {

		case types.SET_SESSIONS: {
			// console.log('Set Session:', action.payload);
    		// make it an indexed collection
			if(!action.payload.length) return {};
			return action.payload.reduce((obj, session) => {
				obj[session._id] = session;
				return obj
			}, {});
		}

		case types.INSERT_SESSIONS: {
			// console.log('Insert Session:', action.payload);
			if(!action.payload.length) return state;
			const sessions =  action.payload.reduce((obj, session) => {
				obj[session._id] = session;
				return obj
			}, {});
			return {...state, ...sessions};
		}

		case types.TOGGLE_SESSION_VIDEO_DONE:{
			let session = {...state[action.payload.sessionId]};
			if(session.videos_done[action.payload.videoId]){
				delete session.videos_done[action.payload.videoId];
			}else{
				session.videos_done[action.payload.videoId] = true;
			}
			return {...state, [action.payload.sessionId]: session}
		}

		case types.SET_SESSION_COMMENTS:
			return {...state, [action.payload.sessionId]: {...state[action.payload.sessionId], comments: action.payload.comments}}

		case types.INSERT_SESSION_COMMENT:
			return {...state,
				[action.payload.sessionId]: {...state[action.payload.sessionId],
					comments: {...state[action.payload.sessionId].comments,
						[action.payload.key]: action.payload.data }
					}
				}

		case types.REMOVE_SESSION_COMMENT:{
			let items = {...state[action.payload.sessionId].comments}
			delete items[action.payload.key]
			return {...state,
				[action.payload.sessionId]: {...state[action.payload.sessionId],
					comments: items
					}
				}
			}

		case types.INSERT_SESSION_USER:
			return {...state,
				[action.payload.sessionId]: {...state[action.payload.sessionId],
					users: {...state[action.payload.sessionId].users,
						[action.payload.user]: true }
					}
				}

		case types.INSERT_SESSION_USERS:
			return {...state,
				[action.payload.sessionId]: {...state[action.payload.sessionId],
					users: action.payload.users
				}
			}


		case types.INSERT_SESSION:
			return {...state, [action.payload._id]: JSON.parse(JSON.stringify(action.payload))};

		case types.REMOVE_SESSION:{
			return omit(state,action.payload)
		}


		case types.SET_SESSION:
			return {...state, [action.payload._id]: action.payload};


		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/sessions.js